import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleAddSupplementToInquiry } from './actions';
import { IAddSupplementToInquiryState } from './slice.interface';

const initialState: IAddSupplementToInquiryState = {
  isLoading: false,
};

export const addSupplementToInquirySlice = createSlice({
  name: 'add-supplement-to-inquiry',
  initialState,
  reducers: {
    removeAddSupplementToInquiry: state => {
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleAddSupplementToInquiry.pending, (state: IAddSupplementToInquiryState) => {
        state.isLoading = true;
      })
      .addCase(handleAddSupplementToInquiry.fulfilled, (state: IAddSupplementToInquiryState) => {
        state.isLoading = false;
        eventBus.emit(EventType.ADD_NEW_SUPPLEMENT_TO_INQUIRY_SUCCESS);
      });
  },
});

export const { removeAddSupplementToInquiry } = addSupplementToInquirySlice.actions;

export default addSupplementToInquirySlice.reducer;
